import React, { useState } from 'react';
import { db } from '../LoginComp/firebase'; // Import Firebase config
import { collection, addDoc } from 'firebase/firestore';
import { motion } from 'framer-motion';
import './stall.css';

function Stall() {
  const [formData, setFormData] = useState({
    organization: '',
    country: '',
    contactPerson: '',
    email: '',
    phone: '',
    stallType: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'stall'), formData);
      alert('Stall booking request submitted successfully!');
      setFormData({ organization: '', country: '', contactPerson: '', email: '', phone: '', stallType: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div className="stall-container">
      <div className="stall-content">
      <h1>Exhibitor Stall Opportunities</h1>
            <p>
            The <strong>Diyatharippu 1st International Optometric Conference</strong> is proud to offer exclusive exhibition opportunities for a diverse range of exhibitors. This event provides a unique platform for organizations to showcase their innovations, share knowledge, and connect with industry leaders. We are inviting the following groups to participate as exhibitors:
            </p>
            <ul>
            <li><strong>Industry Leaders & Companies:</strong> Showcase your products and services to a global audience of professionals in the optometry field.</li>
            <li><strong>Research Institutions:</strong> Present your latest research findings, developments, and advancements in optometry.</li>
            <li><strong>Academic Publishers:</strong> Display your academic resources, publications, and cutting-edge research materials to a highly engaged academic audience.</li>
            </ul>
            <p>
            Join us at this premier event and position your organization at the forefront of the optometric community. This is a fantastic opportunity to expand your brand visibility and network with professionals, researchers, and thought leaders in the industry.
            </p>

            <h2>Benefits of Stall Purchasing</h2>
        <motion.ul 
          className="benefits-list"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.li whileHover={{ scale: 1.02 }} className="benefit-item"> Brand Exposure to Global Audience</motion.li>
          <motion.li whileHover={{ scale: 1.02 }} className="benefit-item"> Showcase Innovations & Research</motion.li>
          <motion.li whileHover={{ scale: 1.02 }} className="benefit-item"> Network with Industry Leaders</motion.li>
          <motion.li whileHover={{ scale: 1.02 }} className="benefit-item"> Marketing Benefits</motion.li>
          <motion.li whileHover={{ scale: 1.02 }} className="benefit-item"> Exclusive Conference Participation</motion.li>
        </motion.ul>

        
        <h2>Book Your Stall</h2>
        
        <div className='stall-price-container'>
          <h3>
          3x2 meter 1 trade stall - $1000 (LKR. 300,000)
          </h3>
        </div>

        <form className="stall-form" onSubmit={handleSubmit}>
          <label>Name of Organization:</label>
          <input type="text" name="organization" value={formData.organization} onChange={handleChange} placeholder="Enter organization name" required />
          
          <label>Country:</label>
          <input type="text" name="country" value={formData.country} onChange={handleChange} placeholder="Enter Your Country" required />
          
          <label>Contact Person:</label>
          <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} placeholder="Enter contact person's name" required />
          
          <label>Email:</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter email" required />
          
          <label>Phone Number:</label>
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter phone number" required />
          
          <label>Type of Stall:</label>
          <select name="stallType" value={formData.stallType} onChange={handleChange} required>
            <option value="">Select Type</option>
            <option value="Industry Companies">Industry Companies</option>
            <option value="Research Institutions">Research Institutions</option>
            <option value="Academic Publisher">Academic Publisher</option>
          </select>
          
          <div className="stall-form-buttons">
            <button type="submit" className="button-stall-form">Submit</button>
            <button type="reset" className="button-stall-form-clear" onClick={() => setFormData({ organization: '', country: '', contactPerson: '', email: '', phone: '', stallType: '' })}>Clear</button>
          </div>
        </form>
      </div>
      
      <div className="stall-images">
        <img src="/stall1.jpg" alt="Stall 1" />
        <img src="/stall2.jpg" alt="Stall 2" />
        <img src="/stall3.jpg" alt="Stall 3" />
        <img src="/stall4.jpg" alt="Stall 4" />
        <img src="/stall1.jpg" alt="Stall 1" />
      </div>
    </div>
  );
}

export default Stall;